/**
 * Capture UTM params from URL on initial page-load and persist them in sessionStorage
 * so any form submitted later in the session can attach them as metadata.
 *
 * Usage: import { getUtm, captureUtmFromLocation } from "./utils/utm";
 *   captureUtmFromLocation() is called once in App.js
 *   getUtm() returns null OR an object { utm_source, utm_medium, utm_campaign, utm_term, utm_content, gclid, fbclid, landing_page, referrer, captured_at }
 */
const KEY = "koning_utm_v1";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];

export function captureUtmFromLocation() {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    let any = false;
    for (const k of UTM_KEYS) {
      const v = params.get(k);
      if (v) {
        found[k] = v.slice(0, 200);
        any = true;
      }
    }
    if (!any) return getUtm();
    found.landing_page = window.location.pathname + window.location.search;
    found.referrer = (document.referrer || "").slice(0, 250) || null;
    found.captured_at = new Date().toISOString();
    sessionStorage.setItem(KEY, JSON.stringify(found));
    return found;
  } catch {
    return null;
  }
}

export function getUtm() {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearUtm() {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(KEY);
}
